import api from '../../api'
import { ActualItemOrigin } from '../../../common/constants'

export const undatedWebEntriesEndpoint = '/web/admin/undated-web-entries'
export const undatedWebEntriesJobsEndpoint = `${undatedWebEntriesEndpoint}/jobs`
export const saveUndatedWebEntryDatesEndpoint = `${undatedWebEntriesEndpoint}/dates`

export type UndatedWebEntriesRequest = {
  tenantId: number
  jobId: number
}

export type JobWithUndatedWebEntries = {
  id: number
  name: string
  customerName: string
  undatedItemCount: number
}

export type UndatedWebEntry = {
  itemGuid: string
  workareaId: number
  workareaName: string
  name: string
  quantity: number
  units: string
  origin: ActualItemOrigin | null
  lastUpdatedAt: string
  lastVisitAt: string | null
  completedAt: string | null
}

export type UndatedWebEntriesResult = {
  jobId: number
  items: UndatedWebEntry[]
}

export type UndatedWebEntryDate = {
  itemGuid: string
  date: string
}

export type SaveUndatedWebEntryDatesRequest = {
  tenantId: number
  jobId: number
  items: UndatedWebEntryDate[]
}

export type SaveUndatedWebEntryDatesResult = {
  updatedItemCount: number
}

export const getJobsWithUndatedWebEntries = async (tenantId: number): Promise<JobWithUndatedWebEntries[]> => {
  return (await api.get(undatedWebEntriesJobsEndpoint, { params: { tenantId } })).data
}

export const getUndatedWebEntries = async (request: UndatedWebEntriesRequest): Promise<UndatedWebEntriesResult> => {
  return (await api.get(undatedWebEntriesEndpoint, { params: request })).data
}

export const saveUndatedWebEntryDates = async (
  request: SaveUndatedWebEntryDatesRequest
): Promise<SaveUndatedWebEntryDatesResult> => {
  return (await api.post(saveUndatedWebEntryDatesEndpoint, request)).data
}
